export const NAVER_CLIENT_ID = process.env.REACT_APP_NAVER_CLIENT_ID;
export const NAVER_CALLBACK_URL = process.env.REACT_APP_NAVER_CALLBACK_URL;
